import React from "react";
import { MDBContainer } from "mdbreact";
import { Helmet } from "react-helmet";
import ReactMarkdown from "react-markdown";

import Layout from "../../components/Layout";

import signwriter from "../../images/headers/SAHeader.jpg";

import text from "../../text/text.json"

import ColourImage from "../../components/ColourImage";

function ServiceAreas() {

    return (
        <>
            <Helmet>
                <title>Artistic Wizard | Service Areas</title>
            </Helmet>
            <Layout>
                <ColourImage text="" overlay="" image={signwriter} />
                <MDBContainer style={{ padding: "20px" }}>
                    <ReactMarkdown>{text.serviceAreas.header1}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.body1}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item1}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item2}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item3}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item4}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item5}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item6}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item7}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item8}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item9}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.item10}</ReactMarkdown>
                    <ReactMarkdown>{text.serviceAreas.body2}</ReactMarkdown>
                    <br />
                </MDBContainer>
            </Layout>
        </>
    )
}

export default ServiceAreas;